export const brazeApi = {
  host: 'https://rest.iad-06.braze.com',
  users: '/users/export/ids',
  token_production: {'Authorization' : 'Bearer 4e964e0a-5113-4b6c-99dd-98556b36c425'}
};

export const brazeEndpoints = {
  contentCards: '/api/v3/content_cards/sync',
  cloudFunction: 'braze-api-call',
}